import { Injectable } from '@angular/core';
import { User } from '../../model';
import { Occ } from '../../occ';
import { Converter } from '../../util';

@Injectable({ providedIn: 'root' })
export class UserProfileNormalizer implements Converter<Occ.User, User> {
  constructor() {}

  convert(source: Occ.User, target?: User): User {
    if (source) {
      if (target === undefined) {
        const { addressData, companyAddress, ...src } = source;
        target = src;
        if (addressData) {
          target.address = addressData;
          target.legacyAddress = true;
        } else {
          target.address = companyAddress;
          target.legacyAddress = false;
        }
      }
    }
    return target;
  }
}
